
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Toc from "../components/Toc/Toc";
import APMPage from "../pages/APMOfflineGuide.jsx";
import Chatbot from "../components/Chatbot/Chatbot.jsx";

export default function SPA() {
  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState("default");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDesktopSidebarCollapsed, setIsDesktopSidebarCollapsed] = useState(false);
  const [focusMode, setFocusMode] = useState(false);
  const [isTocCollapsed, setIsTocCollapsed] = useState(false);

  useEffect(() => {
    const section = searchParams.get("section");
    if (section) {
      setActiveSection(section);
    }
  }, [searchParams]);

  useEffect(() => {
    const main = document.querySelector("main");
    if (main) {
      main.scrollTop = 0;
    }
  }, [activeSection]);

  // Auto-collapse the TOC to its icon whenever focus mode turns on
  useEffect(() => {
    if (focusMode) {
      setIsTocCollapsed(true);
    }
  }, [focusMode]);

  return (
    <div className="app font-display h-screen overflow-hidden flex flex-col bg-background-light dark:bg-[#0f0f0f]">
      {/* Header */}
      {!focusMode && (
      <Header
        setActiveSection={setActiveSection}
        onOpenSidebar={() => setIsSidebarOpen(true)}
      />
    )}

      {/* Main layout */}
      <div className="hide-scrollbar flex-1 min-h-0 flex flex-col lg:flex-row overflow-hidden">
        {/* Sidebar */}
        {!focusMode && (
          <div
            className={`
              no-print flex-shrink-0 w-full min-h-0
              lg:transition-all lg:duration-300
              ${isDesktopSidebarCollapsed ? "lg:w-16" : "lg:w-72"}
            `}
          >
            <Sidebar
              setActiveSection={setActiveSection}
              isOpen={isSidebarOpen}
              onClose={() => setIsSidebarOpen(false)}
              desktopCollapsed={isDesktopSidebarCollapsed}
              onToggleDesktopCollapse={() =>
                setIsDesktopSidebarCollapsed((prev) => !prev)
              }
            />
          </div>
        )}
 
        {/* Main content */}
        <main
          className={`hide-scrollbar flex-1 min-w-0 min-h-0 overflow-y-auto overflow-x-hidden px-4 sm:px-6 lg:px-6 ${
            focusMode ? "pt-6" : "pt-24"
          }`}
        >
          <APMPage activeSection={activeSection} setActiveSection={setActiveSection} />
        </main>

        {/* TOC */}
        <div
          className={`
            no-print flex-shrink-0 min-h-0 overflow-hidden
            lg:transition-all lg:duration-300
            ${isTocCollapsed ? "w-0 lg:w-0 xl:w-0" : "w-full lg:w-72 xl:w-72"}
          `}
        >
          <Toc
            activeSection={activeSection}
            focusMode={focusMode}
            onToggleFocusMode={() => setFocusMode((f) => !f)}
            isCollapsed={isTocCollapsed}
            onToggleCollapse={() => setIsTocCollapsed((c) => !c)}
          />
        </div>
      </div>

      {/* Footer */}
      {!focusMode && (
        <footer className="no-print w-full shrink-0 text-center py-4 text-sm text-gray-500">
          © 2026 ApMoSys Products Private Ltd. All rights reserved.
        </footer>
      )}

      {/* Chatbot */}
      {/* <div className="chatbot no-print">
        <Chatbot />
      </div> */}
    </div>
  );
}